import {
  SignupModel,
  SignupResult,
} from "../../../../model/onboarding/signup/SignupModel";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import ShowToast from "../../../../widget/common/ui/Toast";
import { navigate } from "../../../../service/navigation/Navigation";
import {
  ProfileDetails,
  SignupProfileModel,
} from "../../../../model/onboarding/signup/SignupProfileModel";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import SessionStorage from "../../../../service/storage/SessionStorage";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import {
  DefaultBranch,
  SignupBranchModel,
} from "../../../../model/onboarding/signup/SignupBranchModel";
import { appRoutes } from "../../../../routes/routes";

import {
  routeName as routeNameSignupVerification,
  routeNameForgotPasswordVerification,
} from "../../../../screens/onboarding/signup/account_verification/SignupAccountVerificationScreen";
import {
  RecoverPasswordModel,
  ResetPasswordResult,
} from "../../../../model/onboarding/forgot_password/RecoverPasswordModel";
import { routeName as routeNameSignupVerificationChange } from "../../../../screens/onboarding/signup/account_verification_change/SignupAccountVerificationChangeScreen";

const SignupAccountVerificationProvider =
  new (class SignupAccountVerificationProvider {
    navigate = (url: string) => {
      navigate(url, { replace: true });
    };

    checkAccess = (): boolean => {
      const currentSceen: string = UtilityHelper.getFullPathName();

      UtilityHelper.getFullPathName();

      if (currentSceen === routeNameForgotPasswordVerification) {
        const recoverPasswordSession = SessionStorage.getValue(
          StorageKeys.recover_password_detail
        );
        if (UtilityHelper.isNotEmpty(recoverPasswordSession)) {
          return true;
        }
      } else if (
        [
          routeNameSignupVerification,
          routeNameSignupVerificationChange,
        ].includes(currentSceen)
      ) {
        const verificationSession = SessionStorage.getValue(
          StorageKeys.signup_verification_detail
        );
        if (UtilityHelper.isNotEmpty(verificationSession)) {
          return true;
        }
      }

      return false;
    };

    getVerificationDetail = (): SignupResult | null => {
      console.log("getVerificationDetail", routeNameSignupVerification);

      const currentSceen: string = UtilityHelper.getFullPathName();
      let verificationDetail: SignupResult | null = null;

      console.log("currentSceen", currentSceen);

      if (currentSceen === routeNameForgotPasswordVerification) {
        const recoverPasswordSession = SessionStorage.getValue(
          StorageKeys.recover_password_detail
        );
        if (UtilityHelper.isNotEmpty(recoverPasswordSession)) {
          verificationDetail = JSON.parse(recoverPasswordSession);
        }
      } else if (
        [
          routeNameSignupVerification,
          routeNameSignupVerificationChange,
        ].includes(currentSceen)
      ) {
        const verificationSession = SessionStorage.getValue(
          StorageKeys.signup_verification_detail
        );
        if (UtilityHelper.isNotEmpty(verificationSession)) {
          verificationDetail = JSON.parse(verificationSession);
        }
      }

      return verificationDetail;
    };

    updateDefaultBranch = async (branchId: string) => {
      ApiUrls.init();

      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
      if (
        UtilityHelper.isNotEmpty(branchId) &&
        UtilityHelper.isNotEmpty(accountId)
      ) {
        const url: string = `${ApiUrls.baseUrl}profile/set_default_branch`;
        const body: any = {
          account_id: accountId,
          branch_id: branchId,
        };

        const response: any = await ApiService.postApi(url, body);
        if (response != null) {
          if (response["success"] === "1") {
            const signupBranchModel: SignupBranchModel = response;
            const defaultBranch: DefaultBranch =
              signupBranchModel?.result?.default_branch!;

            this.launchApp(defaultBranch.branch_id!);

            /*  if (!kIsWeb) {
            CachedStorage().cacheString("login_info", "logined");
          } */
          } else {
            ShowToast.error(
              `#${response["errorCode"]} ${response["errorMessage"]}`
            );
          }
        }
      }
    };

    launchApp = (bId: string) => {
      if (UtilityHelper.isNotEmpty(bId)) {
        CacheStorage.saveValue(StorageKeys.launch_status, "1");
        CacheStorage.saveValue(StorageKeys.branch_id, bId);

        navigate(appRoutes.routeNameHome, { replace: true });
      }
    };

    submitPinAPI = async (params: {
      account_id: string;
      verif_code: string;
    }): Promise<SignupProfileModel | null> => {
      ApiUrls.init();

      const appId: string = CacheStorage.getValue(StorageKeys.app_id);
      const deviceId: string = CacheStorage.getValue(StorageKeys.device_id);
      const url: string = `${ApiUrls.baseUrl}profile/activate_signup_profile`;
      const body: any = {
        app_id: appId,
        device_id: deviceId,
        account_id: params.account_id,
        verif_code: params.verif_code,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const signupProfileModel: SignupProfileModel = response;
          const profileDetails: ProfileDetails =
            signupProfileModel?.result?.profile_activation_response
              ?.profile_details!;

          CacheStorage.saveValue(StorageKeys.launch_status, "1");

          // JUST ONLY FOR SIGNUP
          SessionStorage.saveValue(
            StorageKeys.account_id,
            profileDetails.account_id!
          );
          // END JUST ONLY FOR SIGNUP

          CacheStorage.saveValue(
            StorageKeys.company_id,
            profileDetails.company_id!
          );
          CacheStorage.saveValue(
            StorageKeys.account_id,
            profileDetails.account_id!
          );
          CacheStorage.saveValue(StorageKeys.name, profileDetails.name!);
          CacheStorage.saveValue(StorageKeys.logo, profileDetails.logo!);
          CacheStorage.saveValue(StorageKeys.status, profileDetails.status!);
          CacheStorage.saveValue(
            StorageKeys.public_key,
            profileDetails.encryption_keys?.public_key!
          );
          CacheStorage.saveValue(
            StorageKeys.private_key,
            profileDetails.encryption_keys?.private_key!
          );
          CacheStorage.saveValue(StorageKeys.login_status, "1");

          CacheStorage.saveValue(
            StorageKeys.app_id,
            profileDetails?.tokens?.app_id!
          );

          CacheStorage.saveValue(
            StorageKeys.api_token,
            profileDetails?.tokens?.api_token!
          );
          CacheStorage.saveValue(
            StorageKeys.refresh_token,
            profileDetails?.tokens?.refresh_token!
          );

          // DELETE VSIGNUP VERIFCATION DETAIL
          SessionStorage.deleteValue(StorageKeys.signup_verification_detail);
          SessionStorage.deleteValue(
            StorageKeys.signup_third_party_connect_detail
          );

          return signupProfileModel;
        } else {
          ShowToast.error(
            `#${response["errorCode"]} ${response["errorMessage"]}`
          );
        }
      }

      return null;
    };

    resendRecoverPasswordAPI = async (
      accountId: string,
      flag: "0" | "1"
    ): Promise<SignupResult | null> => {
      ApiUrls.init();

      const url: string = `${ApiUrls.baseUrl}profile/resend_recover_password_verification_code`;
      const body: any = {
        profile_id: accountId,
        flag: flag,
      };

      const response: any = await ApiService.postApi(url, body);

      if (response != null) {
        if (response["success"] === "1") {
          const recoverPasswordModel: RecoverPasswordModel = response;
          const resetPasswordResult: ResetPasswordResult =
            recoverPasswordModel?.result?.reset_password_result!;
          const signupResult: SignupResult = {
            account_id: resetPasswordResult?.profile_id!,
            verif_code: resetPasswordResult?.reset_code!,
            expiry_date: resetPasswordResult?.code_expiry!,
            status: resetPasswordResult?.status!,
          };

          return signupResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

    resendVerificationAPI = async (
      accountId: string
    ): Promise<SignupResult | null> => {
      ApiUrls.init();

      const url: string = `${ApiUrls.baseUrl}profile/resend_signup_verification_code`;
      const body: any = {
        account_id: accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsPersonalInfoModel: SignupModel = response;
          const signupResult: SignupResult =
            settingsPersonalInfoModel?.result?.signup_result!;

          return signupResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

    changePhoneAPI = async ({
      accountId = "",
      mobileCodeId = "",
      mobileCode = "",
      mobileNumber = "",
    }: {
      accountId: string;
      mobileCodeId: string;
      mobileCode: string;
      mobileNumber: string;
    }): Promise<SignupResult | null> => {
      ApiUrls.init();

      const url: string = `${ApiUrls.baseUrl}profile/change_signup_mobile_number`;
      const body: any = {
        account_id: accountId ?? "0",
        mobile_code_id: mobileCodeId,
        mobile_code: mobileCode.replaceAll("+", ""),
        mobile_no: mobileNumber.trim(),
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsPersonalInfoModel: SignupModel = response;
          const signupResult: SignupResult =
            settingsPersonalInfoModel?.result?.signup_result!;

          return signupResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

    changeEmailAPI = async (
      accountId: string,
      emailId: string
    ): Promise<SignupResult | null> => {
      ApiUrls.init();

      const url: string = `${ApiUrls.baseUrl}profile/change_signup_email`;
      const body: any = {
        account_id: accountId ?? "0",
        email: emailId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsPersonalInfoModel: SignupModel = response;
          const signupResult: SignupResult =
            settingsPersonalInfoModel?.result?.signup_result!;

          return signupResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };
  })();

export default SignupAccountVerificationProvider;
